import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { light } from '../../../themes/themes'

export const ContainerMenu = styled.div`
  z-index: 9;
  min-width: ${(props) => (props.openMenu || props.isHover ? '240px' : '90px')};

  background: ${({ theme }) => theme.background};
  -webkit-box-shadow: 0 0 21px 0 rgb(89 102 122 / 10%);
  box-shadow: 0 0 21px 0 rgb(89 102 122 / 10%);
`

export const ContainerLogo = styled.div`
  -webkit-box-shadow: -9px 0 20px rgb(89 102 122 / 10%);
  box-shadow: -9px 0 20px rgb(89 102 122 / 10%);
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.enabled ? 'space-between' : 'center')};
  padding: 8px 15px;
  margin-bottom: 2vh;

  img {
    height: 55px;
  }

  .logo {
    display: ${(props) => (props.enabled ? 'block' : 'none')};
  }

  .logoTiny {
    display: ${(props) => (props.enabled ? 'none' : 'block')};
  }
`

export const ContainerItems = styled.div`
  justify-content: ${(props) => (props.openMenu || props.isHover ? 'flex-start' : 'center')};
  display: flex;

  padding-top: 15px;
  ul {
    width: 100%;
    list-style-type: none;
    padding: 0px 20px;
  }
`
export const Button = styled.button`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.primary};
  font-size: 19px;
  height: 19px;
`

export const MenuItem = styled.li``

export const ContentItem = styled.button`
  display: ${(props) => (props.openMenu || props.isHover || props.sub ? 'flex' : null)};
  justify-content: space-between;
  width: 100%;
  font-family: 'Roboto';
  margin-bottom: 16px;
  white-space: nowrap;
  color: ${({ theme, active }) => (active ? color.brand : theme == light ? '#2c323f' : '#C6C1BA')};

  letter-spacing: 0.7px;
  a {
    text-decoration: none;
  }
  &:hover {
    color: ${color.brand};
  }

  span {
    font-family: 'Leelawadee', sans-serif;
    font-weight: 600;
    align-self: flex-end;
    vertical-align: middle;
    display: inline-block;
  }
  svg,
  span {
    vertical-align: middle;
    font-size: 19px;
  }

  .title {
    vertical-align: middle;
    font-weight: 600;
    font-size: 14px;
    padding-left: 10px;
  }
`

export const MenuMobile = styled.div`
  position: fixed;

  left: 0;
  background: ${({ theme }) => theme.background};
  box-shadow: 0 2px 2px 2px rgba(9, 9, 9, 0.5);
  z-index: 5;
  height: 100%;
  width: 100%;
  font-weight: bold;

  opacity: 1;
  transition: all 0.3s ease;
  padding-top: 45px;
  top: ${(props) => (props.active ? '0px' : '-900px')};
  overflow: auto;

  ul {
    overflow: auto;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;

    li {
      list-style-type: none;
      padding: 1.1rem 0;
      width: 100%;
      text-align: center;
      span {
        font-size: 20px !important;
      }
    }
    li:hover {
      background-color: ${color.brand_rgba};
    }
  }
`
export const Arrow = styled.div`
display:inline;
width:100%:
`
